import { create } from 'zustand';

export const usePartyTemplateStore = create((set) => ({
    items: [],
    loading: false,
    error: null,
    columnFilters: {},
    uniqueValues: {},

    paginationData: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        itemsPerPage: 20,
        hasNextPage: false,
        hasPreviousPage: false,
    },

    searchParams: {
        scope: 'all',
        entityType: '',
        code: '',
    },

    isFormOpen: false,
    isEditMode: false,
    isReadOnly: false,
    selectedTemplate: null,
    deleteDialogOpen: false,
    templateToDelete: null,

    setItems: (items) => set({ items }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    setColumnFilters: (columnFilters) => set({ columnFilters }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues: uniqueValues || {} }),
    clearError: () => set({ error: null }),
    setPaginationData: (paginationData) => set({ paginationData }),
    setSearchParams: (params) => set((state) => ({ searchParams: { ...state.searchParams, ...params } })),

    openAddForm: () => set({ isFormOpen: true, isEditMode: false, isReadOnly: false, selectedTemplate: null, error: null }),
    openEditForm: (template) => set({ isFormOpen: true, isEditMode: true, isReadOnly: false, selectedTemplate: template, error: null }),
    openViewForm: (template) => set({ isFormOpen: true, isEditMode: false, isReadOnly: true, selectedTemplate: template, error: null }),
    closeForm: () => set({ isFormOpen: false, isEditMode: false, isReadOnly: false, selectedTemplate: null, error: null }),

    openDeleteDialog: (template) => set({ deleteDialogOpen: true, templateToDelete: template }),
    closeDeleteDialog: () => set({ deleteDialogOpen: false, templateToDelete: null }),
}));
